import { EventType, SourcePages, ImpressionType } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';
import { Badge } from 'components/VehicleBadges/types';
import { VehicleEventInfo } from '../../types';

export type UserExperience = 'local' | 'regional' | 'national';

interface ListingImpressionEventInfo extends VehicleEventInfo {
  vin: string;
  badges: Badge[];
  vdpUserExperience: UserExperience;
}

function event({
  vin,
  badges,
  trackingParams,
  vdpUserExperience,
}: ListingImpressionEventInfo): EventData {
  return {
    event_type: EventType.listingImpression,
    source_page: SourcePages.Vdp,
    impression_type: ImpressionType.vdpView,
    type: ImpressionType.vdpView,
    vin,
    event_context: {
      tracking_params: trackingParams,
      badges,
      vdp_user_experience: vdpUserExperience,
    },
  };
}

export default event;
